<template>
  <v-tooltip bottom open-delay="500">
    <template v-slot:activator="{ on, attrs }">
      <div
        class="presence-pill"
        v-bind="attrs"
        v-on="on"
        @click="$emit('click')"
      >
        <div class="dot-container">
          <span class="pulse-dot"></span>
        </div>

        <span :class="['count', { 'bump-animation': isBumping }]">
          {{ onlineCount }}
        </span>

        <v-icon small class="pill-icon">mdi-account-group-outline</v-icon>
      </div>
    </template>

    <span>{{ tooltipText }}</span>
  </v-tooltip>
</template>

<script>
import axios from "axios";

export default {
  name: "PresencePill",
  props: {
    apiUrl: { type: String, default: "/Users/OnlineUsers" },
    okInterval: { type: Number, default: 15000 },
    retryInterval: { type: Number, default: 5000 }
  },
  data: () => ({
    onlineCount: 0,
    previousCount: 0,
    isBumping: false,
    timerId: null
  }),
  computed: {
    tooltipText() {
      const n = this.onlineCount || 0;
      if (n === 0) return "Sin usuarios en línea";
      if (n === 1) return "1 usuario en línea";
      return `${n} usuarios en línea`;
    }
  },
  mounted() {
    this.fetchOnline();
  },
  beforeDestroy() {
    if (this.timerId) clearTimeout(this.timerId);
  },
  methods: {
    schedule(ms) {
      if (this.timerId) clearTimeout(this.timerId);
      this.timerId = setTimeout(this.fetchOnline, ms);
    },
    async fetchOnline() {
      try {
        const { data } = await axios.get(this.apiUrl, {
          headers: { "Cache-Control": "no-cache" },
          params: { _t: Date.now() }
        });

        const n = (data && typeof data.num_users === "number") ? data.num_users : 0;

        // Si cambió el número → parpadeo
        if (n !== this.onlineCount) {
          this.previousCount = this.onlineCount;
          this.onlineCount = n;
          this.triggerBump();
        }

        this.schedule(this.okInterval);
      } catch {
        this.schedule(this.retryInterval);
      }
    },
    triggerBump() {
      this.isBumping = true;
      setTimeout(() => (this.isBumping = false), 600);
    }
  }
};
</script>

<style scoped>
/* Contenedor Principal */
.presence-pill {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(0, 0, 0, 0.08);
  gap: 6px;
  cursor: pointer;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.presence-pill:hover {
  background: #ffffff;
  border-color: #2196F3;
  box-shadow: 0 4px 12px rgba(33, 150, 243, 0.15);
  transform: translateY(-1px);
}

/* Punto de Presencia */
.dot-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
}

.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #4CAF50; /* Success color */
  position: relative;
}

.pulse-dot::after {
  content: "";
  position: absolute;
  top: 0; left: 0;
  width: 100%; height: 100%;
  border-radius: 50%;
  background: inherit;
  animation: ripple 2s infinite;
}

@keyframes ripple {
  0% { transform: scale(1); opacity: 0.6; }
  100% { transform: scale(2.5); opacity: 0; }
}

/* Contador */
.count {
  font-family: 'Roboto', sans-serif;
  font-weight: 600;
  font-size: 0.875rem;
  color: #455A64;
  min-width: 10px;
  text-align: center;
}

/* Animación cuando cambia el número */
.bump-animation {
  animation: soft-bump 0.5s ease;
  color: #2196F3 !important; /* Primary color durante el cambio */
}

@keyframes soft-bump {
  0% { transform: scale(1); }
  40% { transform: scale(1.25); }
  100% { transform: scale(1); }
}

/* Icono */
.pill-icon {
  color: #78909C !important;
  font-size: 16px !important;
}

.presence-pill:hover .pill-icon {
  color: #2196F3 !important;
}
</style>